<template>
  <div class="main_Container">
    <section class="p-4 detailsView">
      <div class="container-fluid">
        <div v-show="this.isloading" class="data__loading">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <div class="card" v-show="!this.isloading">
          <div class="card-header">
            <h3 class="card-header-title">تفاصيل الاختبار</h3>
          </div>
          <div class="card-body">
            <form>
              <div class="card-body__form">
                <!-- Exam Main Info -->
                <div class="row">
                  <!-- Exam Title -->
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label for="ExamTitle">عنوان الاختبار</label>
                      <input
                        type="text"
                        class="form-control mt-2"
                        id="ExamTitle"
                        placeholder="عنوان الاختبار"
                        :value="exam.title"
                        readonly
                      />
                    </div>
                  </div>
                  <!-- Exam Duration -->
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label for="ExamDuration">مدة الاختبار</label>
                      <input
                        type="number"
                        class="form-control mt-2"
                        id="ExamDuration"
                        :value="exam.duration"
                        readonly
                      />
                    </div>
                  </div>
                  <!-- Exam Degree -->
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label for="ExamDegree">مجموع الاختبار</label>
                      <input
                        type="number"
                        class="form-control mt-2"
                        id="ExamDegree"
                        :value="exam.degree"
                        readonly
                      />
                    </div>
                  </div>
                  <!-- Exam Start -->
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label for="ExamStartDate">بداية الاختبار</label>
                      <input
                        type="datetime-local"
                        class="form-control mt-2"
                        id="ExamStartDate"
                        :value="exam.start_date"
                        readonly
                      />
                    </div>
                  </div>
                  <!-- Exam End -->
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label for="ExamEndDate">نهاية الاختبار</label>
                      <input
                        type="datetime-local"
                        class="form-control mt-2"
                        id="ExamEndDate"
                        :value="exam.end_date"
                        readonly
                      />
                    </div>
                  </div>
                  <!-- Categories -->
                  <div
                    class="col-lg-6"
                    v-if="this.exam.fullCategoriesInfo != null"
                  >
                    <div class="form-group">
                      <label>التصنيف الحالى</label>

                      <div class="categories">
                        <ul class="pe-2">
                          <li
                            v-for="category in this.exam.fullCategoriesInfo"
                            :key="category.category_id"
                          >
                            - {{ category.title }}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <!-- Status -->
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label for="examStatus">حالة الاختبار</label>
                      <select
                        class="form-select form-control mt-2"
                        aria-label="Default select "
                        v-model="exam.status"
                        disabled
                      >
                        <option selected disabled value="">
                          اختار حالة الاختبار
                        </option>
                        <option :value="0">حفظ داخل مسودة</option>
                        <option :value="1">نشر</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label for="examRepeat">امكانية اعادة الاختبار</label>
                      <select
                        class="form-select form-control mt-2"
                        aria-label="Default select "
                        v-model="exam.isRepeat"
                        disabled
                      >
                        <option selected disabled value="">
                          امكانية اعادة الاختبار
                        </option>
                        <option :value="false">لا يمكن اعادة الاختبار</option>
                        <option :value="true">يمكن اعادة الاختبار</option>
                      </select>
                    </div>
                  </div>
                  <!-- Questions Table -->
                  <div class="col-lg-12">
                    <!-- Add Categories Select -->
                    <div class="adding__content mt-4">
                      <!-- Show All Files -->
                      <div
                        class="table-responsive"
                        v-show="this.exam.questions.length > 0"
                      >
                        <Transition name="scale" mode="out-in">
                          <table
                            class="table table-bordered styled-table subject-table full-width table-striped"
                          >
                            <thead>
                              <tr>
                                <th class="fit" scope="col">الرقم</th>
                                <th style="width: 30%" scope="col">السؤال</th>
                                <th scope="col">الاجابات</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(question, index) in this.exam.questions"
                                :key="index"
                              >
                                <th class="text-center" scope="row">
                                  {{ index + 1 }}
                                </th>
                                <td>
                                  <span
                                    v-if="question.questionType == 3"
                                    v-html="question.title"
                                  ></span>
                                  <img
                                    v-if="question.questionType == 1"
                                    class="w-100"
                                    :src="question.url"
                                    alt="QuestionImage"
                                  />
                                </td>
                                <td>
                                  <ul class="pe-0">
                                    <li
                                      v-for="(
                                        answer, index
                                      ) in question.answers"
                                      :key="index"
                                      :class="{
                                        red: question.isRight == index,
                                      }"
                                    >
                                      {{ index + 1 }}-
                                      {{ answer.title }}
                                    </li>
                                  </ul>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </Transition>
                      </div>
                      <!-- if no data to show -->
                      <div v-show="this.exam.questions.length == 0">
                        <Transition name="scale" mode="out-in">
                          <div class="no-data mt-0">
                            <i class="icon fas fa-exclamation-circle"></i>
                            <p>قم بأضافة أسالة للاختبار</p>
                          </div>
                        </Transition>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      exam_id: this.$route.params.id,
      isloading: true,
      exam: {},
    };
  },
  methods: {
    ...mapActions("examsModule", ["getExamById"]),
  },
  async created() {
    this.exam = await this.getExamById(this.exam_id);
    console.log("exam", this.exam);
  },
  computed: {
    ...mapGetters("examsModule", ["isLoading"]),
  },
  mounted() {
    this.isloading = this.isLoading;
  },
  watch: {
    isLoading() {
      this.isloading = this.isLoading;
    },
  },
};
</script>

<style lang="scss" scoped></style>
